import { render, staticRenderFns } from "./CallStatsDetails.vue?vue&type=template&id=4698c0b6&"
import script from "./CallStatsDetails.vue?vue&type=script&lang=js&"
export * from "./CallStatsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CallStatsDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports